import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { ProcessoQuestoes } from "../models/processo-questoes.model";

@Injectable()
export class ProcessoQuestoesService extends BaseService<ProcessoQuestoes> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public listQuestion(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-question/' + id, { headers: this.headers });
  }

  public updateOrdem(obj: any): Observable<any> {
    return this.http.put<any>(this.baseUrl, obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pre-projeto/processo-questoes';
  }
}